import React from 'react';
import { omit } from 'lodash';
import { Page } from '@fiverr-private/perseus';
import ListingsPerseus from '../components/ListingsPerseus';
import withRequestContext from '../components/hoc/withRequestContext';
import tracker from '../service/tracker';
import { initializeLogoMakerTracker } from '../service/initializeLogoMakerTracker';
import { ClientListingsPropTypes } from '../types';
import { ErrorPage } from '../components/common';

class ClientListings extends Page {

    constructor(props) {
        super(props);

        tracker.initialize(omit(props.tracking, 'logoMakerTrackingProps'));

        initializeLogoMakerTracker(props);
    }

    render() {

        const {
            listings,
            appData,
            displayData,
            topBarSorting,
            errorContext,
            assumedLanguage,
            requestContext,
            knownCrawler
        } = this.props;

        if (errorContext) {
            return (
                <ErrorPage errorContext={errorContext}/>
            );
        }
        return (
            <ListingsPerseus displayData={displayData}
                topBarSorting={topBarSorting}
                listings={listings}
                appData={{ ...appData, assumedLanguage }}
                requestContext={requestContext}
                knownCrawler={knownCrawler}/>
        );
    }
}

ClientListings.propTypes = ClientListingsPropTypes;

const ListingsWithRequestContext = withRequestContext(ClientListings);

export default ListingsWithRequestContext;
